import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function DefenseServices() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" dir="ltr">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link className="flex items-center" to="/">
              <img 
                alt="VIPA Trading Company" 
                className="h-12 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/">
                Home
              </Link>
              <div className="relative">
                <button 
                  className="text-[#E71B25] hover:text-[#d11620] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Services
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000]">
                    <div className="py-2">
                      <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Construction & Roads
                      </Link>
                      <Link to="/services/oil" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Oil & Gas
                      </Link>
                      <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Gold Trading
                      </Link>
                      <Link to="/services/defense" className="block px-4 py-3 text-[#E71B25] bg-[#F7F7F7] hover:text-[#d11620] transition-colors text-left font-medium">
                        Defense Systems
                      </Link>
                      <Link to="/services/consultation" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Consulting
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/about">
                About Us
              </Link>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/contact">
                Contact
              </Link>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <button 
                type="button" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                onClick={() => window.open('#contact-form', '_self')}
              >
                Contact Us
              </button>
            </div>

            <button 
              className="lg:hidden text-[#595A5C] cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Breadcrumbs */}
        <section className="py-4 bg-[#F7F7F7]">
          <div className="container mx-auto px-4">
            <nav className="flex items-center space-x-2 text-sm">
              <Link to="/" className="text-[#595A5C] hover:text-[#E71B25] transition-colors">
                Home
              </Link>
              <i className="ri-arrow-right-s-line text-[#595A5C]"></i>
              <Link to="/services" className="text-[#595A5C] hover:text-[#E71B25] transition-colors">
                Services
              </Link>
              <i className="ri-arrow-right-s-line text-[#595A5C]"></i>
              <span className="text-[#E71B25] font-medium">Defense Systems</span>
            </nav>
          </div>
        </section>

        {/* Hero Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h1 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6 leading-tight">
                  Defense Systems
                </h1>
                <p className="text-lg text-[#595A5C] leading-relaxed mb-8">
                  We specialize in defense and security systems with the highest international standards, ensuring full compliance with export controls and end-user certification requirements.
                </p>
              </div>
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0af4202858430aa95a40178157bf80aa.jpg"
                  alt="Defense systems with certified documentation"
                  className="w-full h-auto rounded-xl shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Service Scope */}
        <section className="py-20 bg-[#F7F7F7]">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Our Service Scope</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="space-y-6 max-w-4xl mx-auto">
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Defense systems supply and integration
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Security and surveillance solutions with advanced technology
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Military vehicle and equipment maintenance services
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Communication systems and tactical equipment
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Training and technical support services
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Logistics coordination and comprehensive documentation
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 bg-[#E71B25] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-[#595A5C] leading-relaxed">
                  Strategic consulting for defense sector investments
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Compliance Standards */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Compliance and Security Standards</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-file-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Certified Documentation</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  All our operations are documented and auditable with complete traceability
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">International Standards</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Testing and certification according to the highest international defense standards
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-global-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Export Control/EUCL</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Full compliance with export control requirements and end-user certificate compliance
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose VIPA */}
        <section className="py-20 bg-[#F7F7F7]">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Why Choose VIPA for Defense?</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-star-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Exceptional Quality</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  We work only with certified defense suppliers meeting the highest quality standards
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Security & Trust</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Full commitment to security standards and regulatory compliance
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-settings-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Flexible Solutions</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Customized and flexible solutions tailored to client defense requirements
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 bg-[#E71B25] text-white">
          <div className="container mx-auto px-4 max-w-4xl text-center">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">Interested in Defense Systems?</h2>
            <p className="text-xl mb-8 leading-relaxed">
              Contact us for a specialized consultation and quote that meets your security and defense requirements.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] hover:bg-gray-100 shadow-sm hover:shadow-md px-8 py-4 text-lg"
                >
                  Contact Us
                </button>
              </Link>
              <a 
                href="mailto:info@vipatradingco.com"
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] px-8 py-4 text-lg"
              >
                Email Us
              </a>
            </div>
          </div>
        </section>

        {/* Contact Forms */}
        <section id="contact-form" className="py-16 bg-white">
          <div className="container mx-auto px-4 max-w-2xl">
            <div className="bg-white rounded-xl shadow-lg p-8 border">
              <h3 className="text-2xl font-bold text-[#2B2C2E] mb-6 text-center">Contact Us</h3>
              <form 
                data-readdy-form 
                id="defense-contact-form" 
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.target as HTMLFormElement);
                  const data = new URLSearchParams();
                  for (const [key, value] of formData.entries()) {
                    data.append(key, value as string);
                  }
                  
                  const submitButton = e.currentTarget.querySelector('button[type="submit"]') as HTMLButtonElement;
                  const originalText = submitButton.textContent;
                  submitButton.textContent = 'Sending...';
                  submitButton.disabled = true;
                  
                  fetch('https://readdy.ai/api/form/d2rb8j2jqms3b5jftrk0', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: data
                  }).then(() => {
                    submitButton.textContent = 'Message Sent!';
                    submitButton.style.backgroundColor = '#10B981';
                    (e.target as HTMLFormElement).reset();
                    setTimeout(() => {
                      submitButton.textContent = originalText;
                      submitButton.disabled = false;
                      submitButton.style.backgroundColor = '';
                    }, 3000);
                  }).catch(() => {
                    submitButton.textContent = 'Error - Try Again';
                    submitButton.disabled = false;
                    setTimeout(() => {
                      submitButton.textContent = originalText;
                    }, 3000);
                  });
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Full Name</label>
                    <input type="text" name="name" required className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Organization</label>
                    <input type="text" name="organization" className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Email</label>
                    <input type="email" name="email" required className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Phone</label>
                    <input type="tel" name="phone" className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Defense Service</label>
                  <select name="service_type" required className="w-full px-4 py-3 pr-8 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent">
                    <option value="">Select Service Type</option>
                    <option value="systems">Defense Systems</option>
                    <option value="surveillance">Security & Surveillance</option>
                    <option value="maintenance">Equipment Maintenance</option>
                    <option value="communication">Communication Systems</option>
                    <option value="training">Training Services</option>
                    <option value="consulting">Defense Consulting</option>
                  </select>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Message</label>
                  <textarea 
                    name="message" 
                    rows={5} 
                    maxLength={500} 
                    required 
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent resize-none" 
                    placeholder="Tell us about your defense requirements..."
                    onChange={(e) => {
                      const remaining = 500 - e.target.value.length;
                      const counter = e.target.parentElement?.querySelector('.char-counter');
                      if (counter) counter.textContent = `${remaining} characters remaining`;
                    }}
                  ></textarea>
                  <div className="char-counter text-xs text-gray-500 mt-1">500 characters remaining</div>
                </div>
                <button type="submit" className="w-full bg-[#E71B25] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#d11620] transition-colors duration-200 whitespace-nowrap">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#2B2C2E] text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2 space-y-6">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center mr-4">
                    <img 
                      alt="VIPA Trading Company" 
                      className="h-16 w-auto" 
                      src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                    />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">VIPA Trading Company</h2>
                    <p className="text-[#E71B25] text-sm font-medium">شركة فيبا التجارية</p>
                  </div>
                </div>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A leading Kuwaiti multi-activity company that works in engineering, oil, trading, armament, and consulting with the highest international standards.
                </p>
                <div className="space-y-3">
                  <a href="mailto:info@vipatradingco.com" className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#E71B25] transition-colors">
                      <i className="ri-mail-line text-sm"></i>
                    </div>
                    info@vipatradingco.com
                  </a>
                  <div className="text-gray-300 text-base inline-flex items-center">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-phone-line text-sm"></i>
                    </div>
                    Kuwait
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/construction"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Construction</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/oil"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Oil & Gas</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/gold"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Gold Trading</Link></li>
                <li><Link className="text-[#E71B25] hover:text-[#d11620] transition-colors text-base cursor-pointer block group" to="/services/defense"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Defense Systems</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/consulting"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Consulting</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Home</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/about"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>About Us</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/contact"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Contact</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/careers"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Careers</Link></li>
              </ul>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-600">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <p className="text-gray-400 text-sm">© 2025 VIPA Trading Company — All rights reserved.</p>
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center gap-4">
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                </div>
                <div className="flex items-center gap-3 md:border-l md:border-gray-600 md:pl-4">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-medal-line text-[#E71B25]"></i>
                    <span>ISO 9001</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-shield-check-line text-[#E71B25]"></i>
                    <span>HSE Certified</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
